import React, { SVGProps } from "react";

export default function SupReturn(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.70455 4.45268C6.50934 5.35262 5.70839 6.02673 4.75 6.02673C3.64543 6.02673 2.75 5.1313 2.75 4.02673C2.75 2.92216 3.64543 2.02673 4.75 2.02673C5.70839 2.02673 6.50934 2.70085 6.70455 3.60079V3.52673H11C14.4518 3.52673 17.25 6.32495 17.25 9.77673C17.25 13.2285 14.4518 16.0267 11 16.0267H4.69879L4.79103 16.1303L5.91333 17.2725L5.20003 17.9734L2.75 15.4799L5.20313 13.0267L5.91023 13.7338L4.61734 15.0267H11C13.8995 15.0267 16.25 12.6762 16.25 9.77673C16.25 6.87724 13.8995 4.52673 11 4.52673H6.70455V4.45268Z"
        fill="currentColor"
      />
    </svg>
  );
}
